import { Link } from "react-router-dom";

const MediaBreadCrumb = ({
    folderStack,
    handleBackClick,
    isLoading,
}: {
    folderStack: { name: string; id: string }[];
    handleBackClick: (index: number, id?: string, name?: string) => void;
    isLoading: boolean;
}) => {
    return (
        <div className="d-sm-flex align-items-center justify-content-start mb-3">
            <div className="page-title-right">
                <ol className="breadcrumb m-0">
                    {folderStack.length > 0 && folderStack[0].name !== "Images" && (
                        <li className="breadcrumb-item fw-bold">
                            <span
                                onClick={() => {
                                    handleBackClick(0, "", "Images"); 
                                }}
                                style={{
                                    color: isLoading ? "#ccc" : "#808080",
                                    cursor: isLoading ? "not-allowed" : "pointer",
                                }}
                            >
                                Images
                            </span>
                        </li>
                    )}

                    {folderStack.map((folder, index) => (
                        <li
                            key={folder.id}
                            className={`breadcrumb-item fw-bold ${index === folderStack.length - 1 ? "active text-secondary" : ""}`}
                            data-testing-Id={"breadCrumb_mediaCenter" + index}
                        >
                            {index === folderStack.length - 1 ? (
                                <span>{folder.name}</span> 
                            ) : (
                                <span
                                    onClick={() => !isLoading && handleBackClick(index, folder.id, folder.name)}
                                    style={{
                                        color: isLoading ? "#ccc" : "#808080",
                                        cursor: isLoading ? "not-allowed" : "pointer",
                                    }}
                                >
                                    {folder.name}
                                </span>
                            )}
                        </li>
                    ))}
                </ol>
            </div>
        </div>
    );
};

export default MediaBreadCrumb;
